import {z} from 'zod';

import {FinancialProductTypeSchema} from '@dms/api/shared';

export const PROMOTIONAL_PHOTO_FINANCING_DISPLAY_SETTING_ID = 'promotional-photo-financing-display';

export const PromotionalPhotoFinancingDisplayModeSchema = z.enum(['ALL', 'PREFERRED']);
export type PromotionalPhotoFinancingDisplayMode = z.infer<
  typeof PromotionalPhotoFinancingDisplayModeSchema
>;

// PREFERRED shows only the first product (in `order`) that has a valid offer for the vehicle.
export const PromotionalPhotoFinancingDisplaySchema = z
  .object({
    mode: PromotionalPhotoFinancingDisplayModeSchema,
    order: z.array(FinancialProductTypeSchema),
  })
  .refine(
    (value) =>
      value.mode !== 'PREFERRED' ||
      (value.order.length > 0 && new Set(value.order).size === value.order.length),
    {message: 'order must be non-empty and unique when mode is PREFERRED', path: ['order']}
  );
export type PromotionalPhotoFinancingDisplay = z.infer<
  typeof PromotionalPhotoFinancingDisplaySchema
>;

export const DEFAULT_PROMOTIONAL_PHOTO_FINANCING_DISPLAY: PromotionalPhotoFinancingDisplay = {
  mode: 'ALL',
  order: ['LEASING', 'BALLOON', 'STANDARD'],
};
